import React, { useRef } from 'react'
import Tooltip from '~/components/common/Tooltip'

interface WrapperProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  onClick?: () => void
  tip: string
  buttonRef?: React.RefObject<HTMLButtonElement>
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>['type']
}

export const Wrapper: React.FC<WrapperProps> = ({
  children,
  onClick,
  tip,
  buttonRef,
  type = 'button',
  ...rest
}) => {
  const localRef = useRef<HTMLButtonElement>(null)
  const ref = buttonRef || localRef

  return (
    <Tooltip content={tip}>
      <button onClick={onClick} type={type} ref={ref} {...rest}>
        {children}
      </button>
    </Tooltip>
  )
}
